import React, {useEffect} from 'react';
import {Box, Typography, Grid, Divider, Card, CardContent, Chip, Button} from '@mui/material';
import useStyles from "../../assets/styles/HomeStyles";
import {Dialog} from "@mui/material";
import {useHistory} from "react-router-dom";
import Icon1 from "../../assets/images/DQProImages/Graphic7.png"
import Icon2 from "../../assets/images/DQProImages/Graphic8.png"
import Icon3 from "../../assets/images/DQProImages/Graphic9.png"
import Icon4 from "../../assets/images/DQProImages/Graphic10.png"
import Icon6 from "../../assets/images/DQProImages/Graphic12.png"
import Icon7 from "../../assets/images/DQProImages/Graphic13.png"
import Icon5 from "../../assets/images/DQProImages/Graphic19.png"
import AccessInfoIcon from "../../assets/images/DQProImages/assess-info-icon.png"
import ProgramInfoIcon from "../../assets/images/DQProImages/product-info-icon.png"
import {getInsiderAssessmentsService} from "../../services/assessments.service";
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@mui/material/IconButton';
import {
    clearChatStateInsiderService, getActiveChatInsiderProgramService,
    getInsiderProgramsService,
    loadChatStateInsiderService
} from "../../services/learning_programs.service";
import {LOCAL_STORAGE_KEYS} from "../../utils/constants";
import {TARGET_AGE_MAP} from "../../utils/META/cat_109";
import LoaderWithBackDrop from "../../components/LoaderWithBackDrop/LoaderWithBackDrop.comp";

const DQProProducts = () => {
    const classes = useStyles();
    const history = useHistory();
    const [open, setOpen] = React.useState(false);
    const [selectedCard, setSelectedCard] = React.useState(null);
    const [insiderProducts, setInsiderProducts] = React.useState([]);
    const [insiderPrograms, setInsiderPrograms] = React.useState([]);
    const [dialogType, setDialogType] = React.useState(null);
    const [hasExistingProgram, setHasExistingProgram] = React.useState(false);
    const [showExistingConfirmation, setShowExistingConfirmation] = React.useState(false);
    const isStartingNewRef = React.useRef(false);
    const [loading, setLoading] = React.useState(false);

    const [typeFilter, setTypeFilter] = React.useState('All');

    const filterOptions = [
        { label: "All", value: "All" },
        { label: "AI Readiness Assessment", value: "AI_READINESS" },
        { label: "AI Literacy Program", value: "DIGITAL_LITERACY" },
        { label: "Program’s Alignment", value: "PROGRAM_ALIGNMENT" },
    ];

    useEffect(() => {
        async function fetchData() {
            setLoading(true);
            try {
                const [assessmentsResp, programsResp] = await Promise.all([
                    getInsiderAssessmentsService(),
                    getInsiderProgramsService()
                ]);

                if (assessmentsResp.error) {
                    console.error(assessmentsResp.error_message);
                } else {
                    setInsiderProducts(assessmentsResp.data.assessments.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)));
                }

                if (programsResp.error) {
                    console.error(programsResp.error_message);
                } else {
                    setInsiderPrograms(programsResp.data.learning_programs.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)));
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                setLoading(false);
            }
        }

        fetchData();
    }, []);

    const handleCardClick = (product) => {
        if (product.enabled) {
            if (product.url) {
                history.push(product.url, { assessment: product.assessmentData });
            } else {
                setSelectedCard(product);
                setDialogType(product.dialogType);
                setOpen(true);
            }
        }
    };

    useEffect(() => {
        let isMounted = true;
        const checkExistingProgram = async () => {
            try {
                const response = await getActiveChatInsiderProgramService();
                const programId = response?.data?.program_id;
                return programId;
            } catch (e) {
                console.log("Error checking existing program:", e);
                return false;
            }
        };

        checkExistingProgram().then((exists) => {
            if (isMounted) setHasExistingProgram(!!exists);
        });
        return () => { isMounted = false; };
    }, []);

    const handleStartNew = async () => {
        if (isStartingNewRef.current) return;
        isStartingNewRef.current = true;
        try {
            const response = await getActiveChatInsiderProgramService();
            const programId = response?.data?.program_id;
            if (programId) {
                try {
                    await clearChatStateInsiderService(programId);
                } catch (err) {
                    console.warn('Failed to clear existing program chat state:', err);
                }
            }
        } catch (e) {
            console.warn("Error starting new program:", e);
        } finally {
            setOpen(false);
            setDialogType(null);
            history.push('/dq_pro/program/creation');
            isStartingNewRef.current = false;
        }
    };

    // Ready-To-Go Solutions products
    const staticReadyProducts = [
        // {
        //     image: Icon1,
        //     title:(
        //         <>
        //            Standardized <br/> AI Readiness <br/> Assessments
        //         </>
        //     ),
        //     enabled: true,
        //     url: '/dq_pro/products/assessments'
        // },
        {
            image: Icon2,
            title:(
                <>
                    Standard <br/> AI Literacy <br/> Courses for Children
                </>
            ),
            enabled: false
        },
        {
            image: Icon4,
            title:(
                <>
                    Standard <br/> Digital Parenting <br/> Courses
                </>
            ),
            enabled: false
        },
        {
            image: Icon3,
            title:(
                <>
                    Standard <br/> AI Literacy <br/> Courses for Teens
                </>
            ),
            enabled: false
        },

    ];

    const dynamicReadyAssessments = insiderProducts.map(assessment => ({
        image   : assessment.image_url,
        title   : assessment.full_name,
        enabled : true,
        url     : `/dq_pro/product/view/${assessment.code}`,
        assessmentData : assessment,
        targetAudience: assessment.user_group_verbose,
    }));

    const dynamicReadyPrograms = insiderPrograms.map(program => ({
        image   : program.image_url,
        title   : program.full_name,
        enabled : true,
        url     : `/dq_pro/products/program/dashboard/${program.code}`,
        assessmentData : program,
        targetAudience: program.target_audience,
    }));

    let readyProducts = [];

    if (typeFilter === "All") {
        readyProducts = [...dynamicReadyAssessments, ...dynamicReadyPrograms, ...staticReadyProducts];
    } else if (typeFilter === "AI_READINESS") {
        readyProducts = [...dynamicReadyAssessments];
    } else if (typeFilter === "DIGITAL_LITERACY") {
        readyProducts = [...dynamicReadyPrograms];
    }

    // const readyProducts = [...staticReadyProducts, ...dynamicReadyProducts];

    // Build Your Own products
    const buildProducts = [
        {
            image: Icon5,
            title: (
                <>
                    Create Your Own <br/> AI Readiness <br/> Assessment
                </>
            ),
            enabled: true,
            dialogType: 'assessment'
        },
        {
            image: Icon6,
            title: (
                <>
                    Create Your Own <br/> AI Literacy <br/> Program
                </>
            ),
            enabled: true,
            dialogType: 'program'
        },
        {
            image: Icon7,
            title: (
                <>
                    Check a <br/> Program’s <br/> Alignment
                </>
            ),
            enabled: false 
        }
    ];

    return (
        <Box className={classes.pageContainer} sx={{mt:{sm:'75px', lg:'auto'},}}>
            <Typography variant="h3" className={classes.title} sx={{ mb: 6, textAlign: 'center' }}>
                Your Product List
            </Typography>
            <Box sx={{ mb: 2, display: 'flex', justifyContent: 'center' }}>
                <select
                    value={typeFilter}
                    onChange={e => setTypeFilter(e.target.value)}
                    style={{
                        width: 300,
                        padding: '8px 12px',
                        fontSize: 16,
                        border: '1.5px solid #ff6468',
                        borderRadius: 8,
                    }}
                >
                    {filterOptions.map(opt => (
                        <option key={opt.value} value={opt.value}>{opt.label}</option>
                    ))}
                </select>
            </Box>

            <Grid
                container
                alignItems="flex-start"
                sx={{flexDirection:{xs:'column',sm:'row'}, justifyContent:{sm:"flex-start",lg:'center'}, flexWrap:{xs:'wrap',sm:'nowrap',}, paddingRight: { sm: '16px' }, maxWidth: {md:undefined, lg:'80%'}, margin: '0' }}
            >

                {/* Build Your Own Solution Column */}
                <Grid item sx={{ width: {xs:'100%',sm:'48%'}, maxWidth: {xs:'100%',sm:'48%'}, paddingRight: { sm: '16px' } }}>
                    <Typography variant="h4" sx={{
                        fontSize: {xs:'27px', sm:'1.825rem', md:'2.125rem'},
                        fontWeight: 'bold',
                        mb: 2,
                        color: '#ff6468',
                        textAlign:'center',
                    }}>
                        Build Your Own
                    </Typography>

                    <Grid container spacing={2}>
                        {buildProducts.map((product, index) => (
                            <Grid item xs={12} sm={6} key={`build-${index}`} sx={{display:'flex'}}>
                                <Card sx={{
                                    position: 'relative',
                                    backgroundColor: product.enabled ? '' : '#e6e4e4',
                                    border: product.enabled ? '1px solid #ff6468': 'none',
                                    borderRadius:'13px',
                                    boxShadow:'none',
                                    width:'100% !important',
                                    minHeight:'270px',
                                    cursor:'pointer',
                                    overflow:'visible',
                                    display:'flex',
                                    flexDirection:'column',
                                }}
                                      onClick={() => handleCardClick(product)}
                                >
                                  {!product.enabled && (
                                    <Chip
                                        label="Coming Soon"
                                        sx={{
                                            position: 'absolute',
                                            top: '14px',
                                            left: '50%',
                                            transform: 'translateX(-50%)',
                                            height: '40px',
                                            width:'75%',
                                            borderRadius:'0px',
                                            backgroundColor: '#000000',
                                            color: 'white',
                                            mb:3,
                                            fontWeight: 'bold',
                                            fontSize:'21px',
                                        }}
                                    />
                                  )}
                                    <CardContent sx={{ p: 3, flex: 1, display:'flex', flexDirection:'column', alignItems:'center', minWidth: 0 }}>
                                        <img src={product.image} className={classes.cardImage} alt="product Image" />
                                        <Typography variant="h5" sx={{fontSize:{xs:'1.2rem', md:'1.5rem'},color: product.enabled ? '' : '#ffffff',lineHeight:'1.2',mt:3, textAlign:'center',fontWeight: 'bold', width: '100%', minWidth: 0, wordBreak: 'break-word' }}>
                                            {product.title}
                                        </Typography>
                                    </CardContent>
                                </Card>
                            </Grid>
                        ))}
                    </Grid>
                </Grid>

                {/* Vertical Divider */}
                <Divider sx={{
                    display: { xs: 'none', sm: 'block' },
                    mx: 2,
                    alignSelf: 'stretch',
                    height: 'auto'
                }}
                    orientation="vertical"
                    variant="middle"
                    flexItem />

                {/* Ready-To-Go Column */}
                <Grid item sx={{ width: {xs:'100%',sm:'48%'}, maxWidth: {xs:'100%',sm:'48%'}, paddingLeft: { sm: '16px' }}}>
                    <Typography variant="h4" sx={{
                        fontWeight: 'bold',
                        fontSize: {xs:'27px', sm:'1.825rem', md:'2.125rem'},
                        mb: 2,
                        color: '#ff6468',
                        textAlign:'center',
                    }}>
                        Ready-To-Go Solutions
                    </Typography>

                    <Grid container spacing={2} sx={{flexDirection:{xs:'column',sm:'row'},}}>
                        {readyProducts.map((product, index) => (
                            <Grid item xs={12} sm={6} key={`ready-${index}`} sx={{display:'flex'}}>
                                <Card sx={{
                                    position: 'relative',
                                    backgroundColor: product.enabled ? '' : '#e6e4e4',
                                    border: product.enabled ? '1px solid #ff6468': 'none',
                                    borderRadius:'13px',
                                    boxShadow:'none',
                                    width:'100% !important',
                                    minHeight:'270px',
                                    cursor:'pointer',
                                    overflow:'visible',
                                    display:'flex',
                                    flexDirection:'column',

                                }}
                                      onClick={() => handleCardClick(product)}
                                >
                                    {!product.enabled && (
                                        <Chip
                                            label="Coming Soon"
                                            sx={{
                                                position: 'absolute',
                                                top: '14px',
                                                left: '50%',
                                                transform: 'translateX(-50%)',
                                                height: '40px',
                                                width:'75%',
                                                borderRadius:'0px',
                                                backgroundColor: '#000000',
                                                color: 'white',
                                                mb:3,
                                                fontWeight: 'bold',
                                                fontSize:'21px',
                                            }}
                                        />
                                    )}
                                    <CardContent sx={{ p: 3, flex: 1, display:'flex', flexDirection:'column', alignItems:'center', pb: product.enabled && product.targetAudience ? '50px !important' : '24px !important', minWidth: 0 }}>
                                        <img src={product.image} className={classes.cardImage} alt="product Image" />
                                        <Typography
                                            variant="h5"
                                            sx={{
                                                fontSize: { xs: '1.2rem', md: '1.5rem' },
                                                color: product.enabled ? '' : '#ffffff',
                                                lineHeight: '1.2',
                                                mt: 3,
                                                textAlign: 'center',
                                                fontWeight: 'bold',
                                                width: '100%',
                                                minWidth: 0,
                                                wordBreak: 'break-word',
                                            }}
                                        >
                                            {product.title}
                                        </Typography>
                                    </CardContent>
                                    {product.enabled && product.targetAudience && (
                                        <Box
                                            sx={{
                                                position: 'absolute',
                                                bottom: 0,
                                                left: 0,
                                                width: '100%',
                                                backgroundColor: '#FFC4AB',
                                                color: '#E52F07',
                                                textAlign: 'center',
                                                py: 1,
                                                fontWeight: 'bold',
                                                fontSize: '14px',
                                                borderBottomLeftRadius: '13px',
                                                borderBottomRightRadius: '13px',
                                            }}
                                        >
                                            {
                                                Array.isArray(product.targetAudience) ? product.targetAudience.map(val => TARGET_AGE_MAP[val] ? TARGET_AGE_MAP[val].label : val)
                                                        .join(', ') : (TARGET_AGE_MAP[product.targetAudience] ? TARGET_AGE_MAP[product.targetAudience].label
                                                        : product.targetAudience)
                                            }

                                        </Box>
                                    )}
                                </Card>
                            </Grid>
                        ))}
                    </Grid>
                </Grid>
            </Grid>

            <Dialog
                open={open}
                onClose={() => {
                    setOpen(false);
                    setDialogType(null);
                }}
                fullWidth
                maxWidth="md"
                PaperProps={{
                    sx: {
                        border: '2px solid #000000',
                        borderRadius: '15px',
                        overflow: {xs:'scroll',sm:'hidden'},
                    }
                }}
            >
                {dialogType === 'assessment' ? (
                    <Box sx={{ p: 4, position: 'relative' }}>
                        <IconButton
                            aria-label="close"
                            onClick={() => setOpen(false)}
                            sx={{
                                position: 'absolute',
                                right: 8,
                                top: 8,
                                color: '#999',
                            }}
                        >
                            <CloseIcon />
                        </IconButton>

                        <Typography variant="h5" sx={{ mt: 2, mb: 4, textAlign: 'center',color:'#ff5757', fontWeight: 'bold' }}>
                            Create Your Own AI Readiness Assessment
                        </Typography>

                        <Grid container spacing={4}>
                            {/* Left Side Image */}
                            <Grid item xs={12} sm={4} md={4} sx={{mx:{sm:'auto', }}}>
                                <Box sx={{ height: 200, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    <img src={AccessInfoIcon} alt="product Image" />
                                </Box>
                                <Button className={classes.popupButton} variant="contained"  sx={{ width: '100%', mt: 4 }}
                                        onClick={()=>{
                                            history.push('/dq_pro/products/assessments');
                                        }}
                                >
                                    Create Now
                                </Button>
                            </Grid>

                            {/* Right Side Content */}
                            <Grid item xs={12} md={8}>
                                <Typography sx={{ mb: 2 }}>
                                    <strong>Clear Insights:</strong> Help your learners rapidly identify their strengths and areas needing improvement in AI readiness with individual scorecards.
                                </Typography>
                                <Typography sx={{ mb: 2 }}>
                                    <strong>Reports for All Stakeholders:</strong> Parent reports and school dashboards to monitor progress and levels of AI readiness.
                                </Typography>
                                <Typography sx={{ mb: 2 }}>
                                    <strong>Evidence-Based Decisions:</strong> Enable your clients to confidently inform curriculum development and policy-making with solid, actionable data.
                                </Typography>
                                <Typography sx={{ mb: 2 }}>
                                    <strong>Curate to your target audience and needs:</strong> Select from a list of indicators that you want to assess for any demographic.
                                </Typography>
                            </Grid>
                        </Grid>
                    </Box>
                ) :
                    showExistingConfirmation ? (
                        // SECOND DIALOG: Confirmation
                        <Box sx={{ p: 4, position: 'relative' }}>
                            <IconButton
                                aria-label="close"
                                onClick={() => {
                                    setShowExistingConfirmation(false);
                                    setOpen(false);
                                }}
                                sx={{
                                    position: 'absolute',
                                    right: 8,
                                    top: 8,
                                    color: '#999',
                                }}
                            >
                                <CloseIcon />
                            </IconButton>
                            <Typography variant="h6" sx={{ mt: 2, mb: 4, textAlign: 'center', color: '#ff5757',}}>
                                You already have an existing program in progress. <br/>Do you want to continue with the existing program or start a new program?
                            </Typography>
                            <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', gap: 2, width: '100%', mt: 4 }}>
                                <Button
                                    className={classes.popupButton}
                                    variant="contained"
                                    sx={{ width: '30%',  fontSize:'15px !important' }}
                                    onClick={() => {
                                        setOpen(false);
                                        setShowExistingConfirmation(false);
                                        history.push('/dq_pro/program/creation');
                                    }}
                                >
                                    Continue
                                </Button>
                                <Button
                                    className={classes.popupButton}
                                    variant="outlined"
                                    sx={{
                                        width: '30%',
                                        borderColor: '#ff5757',
                                        color: '#ff5757',
                                        fontWeight: 'bold',
                                        fontSize:'15px !important'
                                    }}
                                    onClick={() => {
                                        setOpen(false);
                                        setShowExistingConfirmation(false);
                                        handleStartNew();
                                    }}
                                >
                                    Start New Program
                                </Button>
                            </Box>
                        </Box>
                    ) : (
                        // FIRST DIALOG: Intro
                        <Box sx={{ p: 4, position: 'relative' }}>
                            <IconButton
                                aria-label="close"
                                onClick={() => setOpen(false)}
                                sx={{
                                    position: 'absolute',
                                    right: 8,
                                    top: 8,
                                    color: '#999',
                                }}
                            >
                                <CloseIcon />
                            </IconButton>

                            <Typography variant="h5" sx={{ mt: 2, mb: 4, textAlign: 'center',color:'#ff5757', fontWeight: 'bold' }}>
                                Powerful Curriculum and AI/Digital Literacy Program Creation
                            </Typography>

                            <Grid container spacing={4}>
                                {/* Left Side Image */}
                                <Grid item xs={12} sm={4} md={4} sx={{mx:{sm:'auto', }}}>
                                    <Box sx={{ height: 200, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                        <img src={ProgramInfoIcon} alt="product Image" />
                                    </Box>
                                    <Button className={classes.popupButton} variant="contained"  sx={{ width: '100%', mt: 4 }}
                                            onClick={() => {
                                                if (hasExistingProgram) {
                                                    setShowExistingConfirmation(true);
                                                } else {
                                                    handleStartNew();
                                                    setOpen(false);
                                                }
                                            }}
                                    >
                                        {'Build a Program'}
                                    </Button>
                                </Grid>

                                {/* Right Side Content */}
                                <Grid item xs={12} md={8}>
                                    <Typography sx={{ mb: 2 }}>
                                        <strong>Structured Curricula for Any Group:</strong>Generate age-appropriate learning programs organized into clear modules, units, and lessons—perfect for schools, organizations, or community groups.
                                    </Typography>
                                    <Typography sx={{ mb: 2 }}>
                                        <strong>Backed by 100+ International Standards and Frameworks:</strong> All content is high-quality, curated by experts, and backed by 100+ international standards and frameworks to ensure accuracy, relevance, and impact.
                                    </Typography>
                                    <Typography sx={{ mb: 2 }}>
                                        <strong>Media-Rich and Engaging:</strong> Every lesson comes with designed slides with images, videos, and interactive activities to make learning fun and visually engaging.
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Box>
                    )}
            </Dialog>
            <LoaderWithBackDrop loading={loading} />
        </Box>
    );
};

export default DQProProducts;